<div class="rfq-multi-hedge" [ngClass]="{ internal: true }">
  <div class="rfq-multi-hedge-label-wrapper">
    <div class="rfq-multi-hedge-add">
      <img
        src="/assets/plus-big.png"
        alt="add"
        (click)="addHedge()"
        title="Add hedge"
        [ngClass]="{
          'icon-disabled': !canAddHedge() || rfqRunning || isGenericMultiHedge
        }"
      />
    </div>
    <div class="rfq-multi-hedge-label">{{ groupName }} Hedges</div>
  </div>
  <div class="rfq-multi-hedge-formlabels-wrapper" *ngIf="hedges.length > 0">
    <div class="rfq-multi-hedge-formlabels">
      <div>Type</div>
      <div>Amount</div>
      @if (!isGenericMultiHedge) {
        <div>Counterparty</div>
        <div>Direction (offer)</div>
        <div>Direction (bid)</div>
        <div>Hedge Rate</div>
        <div>Expiration Date</div>
      }
      @if (showGenericMultiHedgeFields) {
        <div class="rfq-multi-hedge-formlabels__label">Direction</div>
        <div class="rfq-multi-hedge-formlabels__label">Execution</div>
        <div
          class="rfq-multi-hedge-formlabels__label"
          [ngClass]="{
            'rfq-multi-hedge-formlabels__label--hidden': spotRefsHidden
          }"
        >
          Spot Ref
        </div>
        <div
          class="rfq-multi-hedge-formlabels__label"
          [ngClass]="{
            'rfq-multi-hedge-formlabels__label--hidden': forwardPointsHidden
          }"
        >
          Points
        </div>
        <div
          class="rfq-multi-hedge-formlabels__label"
          [ngClass]="{
            'rfq-multi-hedge-formlabels__label--hidden': fwdRatesHidden
          }"
        >
          Fwd Rate
        </div>
      }
      <div>Settlement Date</div>
      <div *ngIf="hedgeMode === 'DX'">Implied Spot</div>

      @if (showGenericMultiHedgeFields) {
        <div
          class="rfq-multi-hedge-formlabels__label rfq-multi-hedge-formlabels__label--market-data rfq-multi-hedge-formlabels__label--sub-title"
        >
          Market
        </div>
        <div
          class="rfq-multi-hedge-formlabels__label rfq-multi-hedge-formlabels__label--market-data"
        >
          Spot
        </div>
        <div
          class="rfq-multi-hedge-formlabels__label rfq-multi-hedge-formlabels__label--market-data"
        >
          Points
        </div>
        <div
          class="rfq-multi-hedge-formlabels__label rfq-multi-hedge-formlabels__label--market-data"
        >
          Fwd Rate
        </div>
      }
    </div>
    <div class="reason" *ngIf="reason">{{ reason }}</div>
  </div>
  <app-rfq-multi-hedge
    [formData]="hedge"
    (onDelete)="deleteHedge(i)"
    (onChangeInExecutionMode)="changeInExecutionMode($event)"
    [currencyPair]="currencyPair"
    [premiumCcy]="premiumCcy"
    [premiumDate]="premiumDate"
    [counterparty]="hedgeMode === 'Live' ? 'Sales Desk' : groupName"
    [hedgeMode]="hedgeMode"
    [index]="i"
    [legSettlementDate]="firstLegSettlementDate"
    [numOfHedges]="hedges.length"
    [blockVolBasedPriceHedgeChanges]="blockVolBasedPriceHedgeChanges"
    [isPreset]="isPreset"
    [isGenericMultiHedge]="isGenericMultiHedge"
    [pipsHighlightedIndices]="pipsHighlightedIndices"
    [isSettlementDatesSame]="isSettlementDatesSame"
    [firstLegExpiryDate]="legExpiryDates[0]"
    [executionMode]="firstLegExecutionMode"
    [hedgeRateValues]="liveHedgeRates?.[i]"
    [showGenericMultiHedgeFields]="showGenericMultiHedgeFields"
    [marketRates]="marketRates"
    [hedgeQuote]="hedgeQuote"
    [hedge]="hedgeSetupValue"
    (onChangeInSpotRef)="changeInSpotRef($event)"
    (changeInHedgeType)="spotHedgeChange($event)"
    (submitSetupEvent)="submitSetupEvent($event)"
    *ngFor="let hedge of hedges; let i = index"
  ></app-rfq-multi-hedge>
</div>
